<template>
    <tr>
        <td>{{ discountMutation.product_name }}</td>
        <td class="p-3">{{ discountMutation.article_code }}</td>
        <td class="p-3">{{ formatLap(discountMutation.final_price)  }}</td>
        <td class="p-3">{{ formatDate(discountMutation.final_discount_datetime) }}</td>
        <td class="p-3">{{ formatDiscount(discountMutation.final_discount)  }}</td>

        <td class="p-3">
            <counter :can-be-negative="true" :value.sync="newChange" :step="0.5" />

            <input type="hidden" :name="`change[${discountMutation.station_id}][${discountMutation.product_id}]`"
                   v-model="newChange">
            <input type="hidden" :name="`finalLap[${discountMutation.station_id}][${discountMutation.product_id}]`"
                   v-model="discountMutation.final_lap">
            <input type="hidden" :name="`discountId[${discountMutation.station_id}][${discountMutation.product_id}]`"
                   v-model="discountMutation.id">
        </td>

        <td class="p-3">
            {{ formatDiscount(discountChange) }}
        </td>

        <td class="p-3">{{ formatLap(discountMutation.final_lap)  }}</td>
        <td class="p-3">{{ formatLap(finalPrice) }}</td>

        <td class="p-3">
            <div  class="datepicker-container">
                <date-picker :config="datePickerOptions"
                             :name="`date[${discountMutation.station_id}][${discountMutation.product_id}]`"
                             :placeholder="formattedNewDiscountDateTime"
                             :value="newDiscountDateTime"
                             @dp-change="updateNewDiscountDateTime"
                             autocomplete="off"
                             class="form-control bg-white date input-field datetimepicker height-30px"/>
            </div>
        </td>
    </tr>
</template>

<script>
    import moment from 'moment';
    import DatePicker from 'vue-bootstrap-datetimepicker';
    import Counter from '../../Counter'

    export default {
        name: 'FuelDiscountMutationsNewTableRow',

        components: {
            Counter,
            DatePicker
        },

        props: {
            discountMutation: Object
        },

        data() {
            return {
                datePickerOptions: {
                    minDate: new Date(),
                    showClear: true,
                    useCurrent: false,
                },
                newChange: 0,
                newDiscountDateTime: ''
            };
        },

        computed: {
            discountChange() {
                return this.discountMutation.final_discount + this.newChange;
            },

            finalPrice() {
                return this.discountMutation.final_lap - this.discountChange;
            },

            formattedNewDiscountDateTime() {
                return this.newDiscountDateTime ? this.formatDate(this.newDiscountDateTime) : '';
            },

            hasPreviousChange() {
                return this.discountMutation.final_discount > 0;
            },

            hasNewDiscountDateTime() {
                return ! (! this.newDiscountDateTime || ! this.newDiscountDateTime.isValid());
            },

            isFilled() {
                return (this.newChange !== 0 || !this.hasPreviousChange) && this.hasNewDiscountDateTime
            },

            isValid() {
                if (!this.hasNewDiscountDateTime) {
                    return true;
                }

                if (!this.newChange && !this.hasPreviousChange) {
                    return true;
                }

                return this.isFilled;
            }
        },

        methods: {
            formatLap: (float) => (float ? parseFloat(float).toFixed(2) : '0.00').replace('.', ','),

            formatDiscount: (float) => (float ? parseFloat(float).toFixed(1) : '0.0').replace('.', ','),

            formatDate: (date) => date ? (typeof date === 'object' ? date : moment(date)).format('L') : '',

            formatDateTime: (date) => (typeof date === 'object' ? date : moment(date)).format('DD/MM/YYYY H:mm'),

            updateNewDiscountDateTime(value) {
                this.newDiscountDateTime = value ? value.date : '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .datepicker-container {
        position: relative;
    }

    td {
        white-space: nowrap;

        &.reviewer-details {
            display: table-row-group;
            padding-bottom: 0.8rem;
            padding-left: 1rem;
            padding-right: 1rem;
            position: absolute;
            transform: translate3d(0, 100%, 0);
        }
    }
</style>
